export const GET_MUST_KNOW_NOTIFICATION = "get_must_know_notification";
export const GET_MUST_KNOW_NOTIFICATION_FAIL = "get_must_know_notification_fail";
export const GET_MUST_KNOW_NOTIFICATION_SUCCESS = "get_must_know_notification_success";
export const GET_MUST_KNOW_NOTIFICATIONS = "get_must_know_notifications";
export const GET_MUST_KNOW_NOTIFICATIONS_FAIL = "get_must_know_notifications_fail";
export const GET_MUST_KNOW_NOTIFICATIONS_SUCCESS = "get_must_know_notifications_success";
